<template>
<div>
  <section>

    <!-- //TITLE MOBILE -->
    <h1 class="mobile">Résumé</h1>
    <!-- //TITLE MOBILE -->

    <!-- //ILLUSTRATION MOBILE -->
    <div class="mobile block__illustrationHorizontal mb-5">
      <div class="info">
        <h3 class="title">
          <PuSkeleton :loading="isLoading" :count="1" width="200px"  class="blueSkeleton">
            Heureux de vous revoir !
          </PuSkeleton>
        </h3>
        <PuSkeleton :loading="isLoading" :count="2"  class="blueSkeleton">
          <p class="desc"> Les dernières données ont été mises à jour le <span>{{lastResult !== null ? moment(lastResult.date).format('DD/MM/YYYY') : '...'}}</span></p>
        </PuSkeleton>
      </div>
      <img :src="'/img/resume_illustration.png'" alt="illustration">
    </div>
    <!-- //ILLUSTRATION MOBILE -->

    <!-- //CONTENT -->
    <div class="content__resume overflow">
      <b-row>
        <!-- PART MIDDLE -->
        <b-col class="column-middle fullwidth">
          <!-- //TITLE DESKTOP -->
          <h1 class="desktop">Résumé</h1>
          <!-- //TITLE DESKTOP -->


          <!-- //ILLUSTRATION DESKTOP -->
          <div class="desktop block__illustrationHorizontal">
            <div class="info">
              <h3 class="title">
                  <PuSkeleton :loading="isLoading" :count="1" class="blueSkeleton">
                    Heureux de vous revoir !
                  </PuSkeleton>
              </h3>
              <div class="content__desc">
              <PuSkeleton :loading="isLoading" :count="2" class="blueSkeleton">
                <p class="desc"> Les dernières données ont été mises à jour le <span>{{lastResult !== null ? moment(lastResult.date).format('DD/MM/YYYY') : '...'}}</span></p>
              </PuSkeleton>
              </div>
            </div>
            <img :src="'/img/resume_illustration.png'" alt="illustration">
          </div>
          <!-- //ILLUSTRATION DESKTOP -->


          <!-- //SUIVI -->
            <section class="suivi" v-if="haveAccess(ApplicationsAccessEnum.APP_COMMERCIALS)">
              <div class="head">
                <h2>Commerciaux suivi</h2>
                <router-link class="btn btn-blue" to="../commerciaux">Tous</router-link>

              </div>
              <div class="sep"></div>
              <listCommercialResume/>
            </section>
            <!-- //SUIVI -->


          <!-- //CHALLENGES -->
            <section class="challenge" v-if="haveAccess(ApplicationsAccessEnum.APP_CONCOURS)">
              <div class="head">
                <h2>Challenges en cours</h2>
                <router-link class="btn btn-blue" to="../challenges">Tous</router-link>
              </div>

              <div class="sep"></div>

              <!-- SLIDER MOBILE -->
              <div class="block__slider mobile">
                <VueSlickCarousel v-bind="settings">
                  <template v-if="lastContests.length > 0">
                    <div v-for="contest in lastContests" :key="contest.id" class="wrapper">
                      <cardChallengesPicture
                          :subtitle = "'Jeu concours'"
                          :title = contest.title
                          :ranking = "'Classement'"
                          :rankingNumber = contest.totalRank
                          :rankingPrevious = contest.previousRank
                          :rank = contest.rank
                          :score = '"Score"'
                          :scoreNumber = contest.score
                          :target = contest.target
                          :isLoad.sync = isLoading
                          link =  "/challenges/accueil"
                      />
                    </div>
                  </template>
                  <template v-else>
                    <div>
                      Aucun challenges en cours
                    </div>
                  </template>

                  <template  v-if="lastChallengeLoad">
                    <div  class="wrapper">
                      <cardChallengesDate
                          :id = lastChallengeLoad.id
                          :title = lastChallengeLoad.criteria
                          :subtitle = lastChallengeLoad.criteria
                          :startDate =  lastChallengeLoad.startDate
                          :endDate = lastChallengeLoad.endDate
                          :objectiveNumber = lastChallengeLoad.objective
                          :inprogress = lastChallengeLoad.score
                          :state = lastChallengeLoad.target
                          :isLoad.sync = isLoading
                      />
                    </div>
                  </template>
                </VueSlickCarousel>
              </div>
              <!-- SLIDER MOBILE -->

              <div class="desktop">
                <b-row>
                  <template v-if="lastContests.length > 0">
                    <b-col sm="12" lg='6' class="mb-2" v-for="contest in lastContests" :key="contest.id">
                      <cardChallengesPicture
                          :subtitle = "'Jeu concours'"
                          :title = contest.title
                          :ranking = "'Classement'"
                          :rankingNumber = contest.totalRank
                          :rankingPrevious = contest.previousRank
                          :rank = contest.rank
                          :score = "'Score'"
                          :scoreNumber = contest.score
                          :target = contest.target
                          :img = contest.challengeMedia
                          :isLoad.sync = isLoading
                          link =  "/challenges/accueil"
                      />
                    </b-col>
                  </template>
                  <template v-else>
                    <div class="col-12">
                      <p>Aucun challenges en cours</p>
                    </div>
                  </template>
                  <b-col sm="12" lg='6' v-if="lastChallengeLoad">
                    <cardChallengesDate
                            :id = lastChallengeLoad.id
                            :title = lastChallengeLoad.criteria
                            :subtitle = lastChallengeLoad.criteria
                            :startDate =  lastChallengeLoad.startDate
                            :endDate = lastChallengeLoad.endDate
                            :objectiveNumber = lastChallengeLoad.objective
                            :inprogress = lastChallengeLoad.score
                            :state = lastChallengeLoad.target
                            :isLoad.sync = isLoading
                    />
                  </b-col>

                  <!-- FORM CHALLENGE -->
                  <formChallenge @reload="reload()"> </formChallenge>
                </b-row>
              </div>

            </section>
          <!-- //CHALLENGES -->

        </b-col>
        <!-- PART MIDDLE -->
        <Stack height="2rem" class="mobile"></Stack>

      </b-row>
    </div>

    <surveyModal> </surveyModal>
    <!-- //CONTENT -->


    <!-- <Footer/> -->

  </section>
    </div>

</template>




<script>
import { mapGetters } from 'vuex'
import formChallenge from '../../../module/modal/FormChallenge'
import listCommercialResume from '../../../module/list/ListCommercialResume'
import cardChallengesPicture from '../../../module/card/CardChallengesPicture'
import cardChallengesDate from '../../../module/card/CardChallengesDate'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import ApiService from '../../../../services/ApiService'
import ApiAuthentificationService from '../../../../services/ApiAuthenticationService'
import Stack from '../../../module/stack/Stack'
import surveyModal from "@/components/module/modal/SurveyModal";
import moment from "moment/moment";
import {ApplicationsAccessEnum} from "@/services/Enum/ApplicationsAccessEnum";


export default {
  name:"resumeHome",
    components:{
      formChallenge,
      listCommercialResume,
      cardChallengesPicture,
      cardChallengesDate,
      VueSlickCarousel,
      Stack,
      surveyModal,
    },
    computed: {
      ApplicationsAccessEnum() {
        return ApplicationsAccessEnum
      },
      ...mapGetters([
        'getCurrentCodePtf',
          'getIsMobile'
      ]),
      moment() {
        return moment
      },
    },
    data () {
      return {
        isLoading:true,
        lastResult: null,
        nationalIndicators: null,
        lastContests: [],
        lastChallengeLoad:{},
        survey: false,
        currentUser: {},
        settings: {
            "focusOnSelect": true,
            "infinite": false,
            "slidesToShow": 1,
            "variableWidth": true,
            "speed": 500,
            "initialSlide": 0,
            "arrow":false,
            isMobile:false,
        }
      }
    },
    created (){
      this.isMobile = this.getIsMobile;
      this.currentUser = ApiAuthentificationService.getCurrentUser();

      this.getData().then(() => {
        this.isLoading = false
        /*if(!this.survey) {
          this.$root.$emit('bv::show::modal', 'survey-modal', '#btnShow');
        }*/
      }
      );
    },
    mounted() {
      this.$store.dispatch('showHeader',true);
    },
  methods : {
    haveAccess(accessType) {
      if (this.currentUser.applicationsAccess) {
        if (typeof this.currentUser.applicationsAccess === 'object') {
          return Object.values(this.currentUser.applicationsAccess).includes(accessType);
        }
        return this.currentUser.applicationsAccess.includes(accessType);
      }
      return false;
    },
      async getData(){
        let promises = [];
        if (this.haveAccess(ApplicationsAccessEnum.APP_CONCOURS)) {
          //last concours
          promises.push(ApiService.getConcoursApi().getCards(ApiAuthentificationService.getCurrentUser().id,20).then((data) => {
            if (data.data.length > 0) {
              this.lastContests = [];

              for (let i = 0; i < 20; i++) {
                if (data.data[i] !== undefined) {
                  let contest = data.data[i];

                  contest.challengeMedia = data.data[i].image ? data.data[i].image.id : '';

                  this.lastContests.push(contest);
                }
              }
            }
          }));
          //Les challenges
          promises.push(ApiService.getChallengeApi().get(ApiAuthentificationService.getCurrentUser().id,1).then((data) => {
            this.lastChallengeLoad = null;
            if (data && data.data.length > 0){
              this.lastChallengeLoad = data.data[0];
            }
          }));
        }

        if (this.haveAccess(ApplicationsAccessEnum.APP_PARCOURIR) || this.haveAccess(ApplicationsAccessEnum.APP_PARCOURIR_NATIONAL)) {
          promises.push(ApiService.getParcourirApi().getLastResult().then((data) => {
            this.lastResult = data.data;

            if (this.haveAccess(ApplicationsAccessEnum.APP_PARCOURIR_NATIONAL)) {
              promises.push(ApiService.getParcourirApi().getPersonalMonitoringResult(ApiAuthentificationService.getCurrentUser().id, this.lastResult.id).then((data) => {
                this.nationalIndicators = data.data;
              }, () => this.nationalIndicators = null));
            }

          }, () => this.lastResult = null));
        }

        /*promises.push(ApiService.getSurveyApi().get().then((data) => {
          this.survey = data.data;
        }));*/

        await Promise.all(promises);
      },
      reload(){
        this.isLoading = true;
        this.getData().then(() => this.isLoading = false);
      },
      getNationalIndicatorsValues() {
        if (!this.nationalIndicators) {
          return null;
        }
        if (this.getCurrentCodePtf) {
          return this.nationalIndicators.national[this.getCurrentCodePtf];
        }

        return this.nationalIndicators.national?.total;
      },
    getResultN(element, index) {
      if (index?.includes('_a')) {
        if (element[index.split('_a')[0] + '_c']) {
          return element[index.split('_a')[0] + '_c']
        } else {
          return '-';
        }
      }

      if (index?.includes('DTptf')) {
        if (element[index.split('DTptf')[0] + 'DTptf3b.']) {
          return element[index.split('DTptf')[0] + 'DTptf3b.']
        } else {
          return '-';
        }
      }

      return element[index];
    },
    getResultN1(element, index) {
      if (index?.includes('_a')) {
        return element[index];
      }

      if (index?.includes('DTptf')) {
        if (element[index.split('DTptf')[0] + 'DTptf0b.']) {
          return element[index.split('DTptf')[0] + 'DTptf0b.']
        }
      }

      return '-';
    },
    },
  watch:{
    getCurrentCodePtf(){
      this.isLoading = true;
      this.getData().then(() => this.isLoading = false);
    },
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
};
</script>
